var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterGreenPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-904 -412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0A8.5,8.5,0,1,0,17,8.5,8.492,8.492,0,0,0,8.5,0Z",
    transform: "translate(904 412)",
    fill: "#a8ddc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,7.3,7.3,8.5,4.25,5.449,1.2,8.5,0,7.3,3.052,4.25,0,1.2,1.2,0,4.25,3.052,7.3,0,8.5,1.2,5.449,4.25Z",
    transform: "translate(912.5 414.49) rotate(45)",
    fill: "#0b572f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGreenPlus);
export default __webpack_public_path__ + "static/media/filter_green-plus.49f1ab96de956c8817b3f9d51de91618.svg";
export { ForwardRef as ReactComponent };